import { FC, useMemo } from 'react';
import CardList from '../CardList';
import {
  ExtraAttributesCarrierType,
  CommonAttributesProps,
  CarrierType,
} from 'screens/AccessExpressV3/accessExpress.types';

interface CarrierProps extends CommonAttributesProps {
  options: ExtraAttributesCarrierType[];
  selected: ExtraAttributesCarrierType | null;
  setSelected: (v: ExtraAttributesCarrierType) => void;
}

const mapCarrierTypeTitle: Record<CarrierType, string> = {
  Granite: 'Granite',
  'Granite Multi Carrier SIM': 'Granite Multi-Carrier SIM',
  'VERIZON WIRELESS': 'Verizon Wireless',
  ATT: 'AT&T',
  TMOBILE: 'T-Mobile',
};

const Carrier: FC<CarrierProps> = ({
  handleStep,
  step,
  options,
  selected,
  setSelected,
}) => {
  const onSelect = (item: ExtraAttributesCarrierType) => {
    handleStep && handleStep(step ?? 1);
    setSelected(item);
  };

  const _options = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        id: option.carrier_name,
        title: mapCarrierTypeTitle[option.carrier_name] ?? option.carrier_name,
        item: option,
      })),
    [options],
  );

  return (
    <>
      <CardList
        title="Carrier"
        selected={selected?.carrier_name || null}
        onClick={(item) => onSelect(item as ExtraAttributesCarrierType)}
        options={_options}
      />
    </>
  );
};

export default Carrier;
